import { paths } from "helpers/paths";
import React from "react";

export default function WithoutSigningFilesInfo() {
    return (
        <div className="alert alert-info mb-3">
            <div className="font-weight-bold mb-1">Если нужно сформировать документ без печати и подписи</div>
            <div>
                При необходимости отправить сформированный документ по ЭДО или скачать его без печатей сформируйте его
                используя кнопку "Создать документ без печати и подписи". Настройте интеграцию с{" "}
                <a href={paths.integrationItem("kontur")} target="_blank" rel="noreferrer">
                    Контур.Диадок
                </a>
            </div>
        </div>
    );
}
